import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { CardComponent } from '../../../components/card/card.component';
import { ReviewItemComponent } from '../../../components/review-item/review-item.component';
import { FormatFirstNameLastLetterPipe } from '../../../pipes';
import { JobClientDetails } from '../../../types';
import { UserProfileComponent } from '../user-profile/user-profile.component';

@Component({
    selector: 'lib-client-user-profile',
    imports: [CommonModule, ReviewItemComponent, CardComponent, UserProfileComponent, FormatFirstNameLastLetterPipe],
    templateUrl: './client-user-profile.component.html',
    styleUrl: './client-user-profile.component.css'
})
export class ClientUserProfileComponent {
    backButtonUrl = input<string>();
    user = input<JobClientDetails | null>(null);

    router = inject(Router);

    backDefaultHref = '/settings';

    constructor() {
        this.backDefaultHref = this.router.getCurrentNavigation()?.extras.state?.['data']['backUrl'] || '/settings';
    }
}
